import React, { useEffect, useState, useRef } from 'react'
import { CountMetricCard } from '../common/atoms'
import { Table, Pagination, SquareTabbar } from '../common/molecules'
import { EmployeeDataHoc } from '../../utils/hocs'
import handleAppError from '../handlers/handleAppError'
import { manageEmployeesErrorTableSchema as tableSchema } from '../../schemas/table'
import { EMPLOYEE_PAGE_CONTENT } from '../../constants/employeeData'
import { CorrectTick } from '../../assets/images'

const convertDob = (dob) => {
  if (dob) {
    const arr = dob.split('-')
    if (arr.length === 3) [arr[0], arr[2]] = [arr[2], arr[0]]
    dob = arr.join('-')
  }
  return dob
}

const ViewResult = ({ history, location }) => {
  const { id } = location.state
  const [metricValues, setMetricValues] = useState([0, 0, 0, 0])

  const query = new URLSearchParams(location.search).get('of')
  const { [query]: CONTENT } = EMPLOYEE_PAGE_CONTENT

  const [paginationData, setPaginationData] = useState({
    successData: { totalpages: metricValues[2], curpage: 0, curData: [] },
    failedData: { totalpages: metricValues[3], curpage: 0, curData: [] },
  })
  const [flag, setFlag] = useState(false)
  const list = useRef(null)

  const paginateHandler = async (page, type) => {
    const { fetch_recent_upload_details } = CONTENT
    try {
      const res = await fetch_recent_upload_details({ id, page })
      const data = res.data

      if (data) {
        const { customers = [], failed_rows = [], validation_passed_records = 0, total_records_processed = 0, total_records_successful = 0 } = data
        const successData = customers.map((item) => {
          return { ...item, vip: item.vip ? 'Yes' : 'No', date_of_birth: convertDob(item.date_of_birth), employee_office_location: item.sponsor_location, email: item.guardian_email ? item.guardian_email : item.email }
        })

        const failedData = failed_rows.map((item) => {
          item = JSON.parse(item)
          return { ...item, vip: item.vip ? 'Yes' : 'No', sponsor_department: item.department, job_involves: item.job_required, employee_address: item.address, dc_name_and_location: item.provider }
        })

        const curpage = page
        const curData = type === 'successData' ? successData : failedData
        setPaginationData((prevState) => {
          return { ...prevState, [type]: { ...prevState[type], curpage, curData } }
        })

        const total_failed_records = (total_records_processed || 0) - (total_records_successful || 0)
        list.current = [`Failed Data (${total_failed_records})`, `Successful Data (${total_records_successful || 0})`]
        setMetricValues([total_records_processed || 0, validation_passed_records || 0, total_records_successful || 0, total_failed_records])
      }
    } catch (err) {
      handleAppError(err)
    }
  }

  useEffect(() => {
    paginateHandler(0, 'failedData')
  }, [])

  const navigateTab = (text) => {
    const check = text === list.current[1]
    const type = check ? 'successData' : 'failedData'
    paginateHandler(0, type)
    setFlag(check)
  }

  return (
    <EmployeeDataHoc 
      title={CONTENT['title']}
      breadcrumb={[CONTENT['title'] === 'Pre employement bulk checkups' ? 
      { text: 'Pre employment', link: '/pre-employee-checkup'  } : 
      { text: 'Manage Employees', link: '/employee-registration' }, CONTENT['breadcrumb']]} 
      close={() => history.goBack()}
    >
      <div className='flex mt-6'>
        <CountMetricCard metricValue={metricValues[0]} metricDescription= {`${query=== 'family_addition' ? 'Family members' : 'Employees'} data uploaded`} svgsrc={CorrectTick} classes='w-1/3 mr-2' />
        <CountMetricCard metricValue={metricValues[1]} metricDescription= {`${query=== 'family_addition' ? 'Family members' : 'Employees'} data validation passed`} svgsrc={CorrectTick} classes='w-1/3 mr-2' />
        <CountMetricCard metricValue={metricValues[2]} metricDescription= {`${query=== 'family_addition' ? 'Family members' : 'Employees'} data successfully uploaded`} svgsrc={CorrectTick} classes='w-1/3' />
      </div>
      {list.current && <SquareTabbar list={list.current} handler={navigateTab} classes='mt-6' />}
      <Table
        headers={CONTENT['recent_uploads_headers']}
        customHeaders={CONTENT['tableHeaders']}
        data={flag ? paginationData.successData.curData : paginationData.failedData.curData}
        tableschema={tableSchema}
        classes='mt-3'
      />
      { flag  && <Pagination
        totalpages={flag ? Math.ceil(metricValues[2] / 10) : Math.ceil(metricValues[3] / 10)}
        totalresults={flag ? metricValues[2] : metricValues[3]}
        curpage={flag ? paginationData.successData.curpage : paginationData.failedData.curpage}
        handler={paginateHandler}
        args={flag ? ['successData'] : ['failedData']}
      />}
    </EmployeeDataHoc>
  )
}

export default ViewResult
